import {
    RiArrowDownSLine,
    RiArrowUpSLine,
    RiCheckboxBlankCircleLine, RiCheckboxCircleFill, RiCloseCircleFill, RiLoader2Fill, RiPauseCircleFill,
} from "@remixicon/react";
import classNames from "classnames";
import React from "react";
import { TicketTask, TicketTaskState } from "../../../../__generated__/api";
import FilterPanel from "../../../filters/FilterPanel";
import Badge, { VariantType } from "../../../theme/badge/Badge";
import EditableLabel from "../editable-label/EditableLabel";
import Styles from "./TaskStatus.module.scss";
import { Filters } from "../../../filters/Filters";
import Dropdown from "../../../theme/dropdown/Dropdown";

const STATUS_TEXT = {
    [TicketTaskState.Open]: {
        variant: "info",
        icon: <RiCheckboxBlankCircleLine />,
        text: "To Do",
    },

    [TicketTaskState.InProgress]: {
        variant: "warning",
        icon: <RiLoader2Fill />,
        text: "In Progress",
    },
    [TicketTaskState.OnHold]: {
        variant: "yield",
        icon: <RiPauseCircleFill />,
        text: "On Hold",
    },
    [TicketTaskState.Finished]: {
        variant: "success",
        icon: <RiCheckboxCircleFill />,
        text: "Done",
    },
    [TicketTaskState.NotApplicable]: {
        variant: "yield",
        icon: <RiCloseCircleFill />,
        text: "Not Applicable",
    },

    [TicketTaskState.Rejected]: {
        variant: "danger",
        icon: <RiCloseCircleFill />,
        text: "Rejected",
    },
};

export default function TaskStatus({
    task, onChange, status, className,
}: {
    task: TicketTask;
    onChange: (status: TicketTaskState) => void;
    status: TicketTaskState;
    className?: string;
}) {
    const selectedStatus = status ?? TicketTaskState.Open;
    const selected = STATUS_TEXT[selectedStatus];

    return (
        <Dropdown className={Styles["status-select"]}>
            <Dropdown.Toggle variant="none" className={Styles["status-toggle"]}>
                <Badge variant={selected.variant as VariantType}>
                    {selected.icon}
                    {" "}
                    {selected.text}
                    {" "}
                    <Dropdown.ToggleIcon />
                </Badge>
            </Dropdown.Toggle>
            <Dropdown.Menu className={Styles.menu}>
                <FilterPanel
                    isMulti={false}
                    itemClassName={Styles["status-item"]}
                    categories={Object.entries(STATUS_TEXT)
                        .filter(([value]) => value !== selectedStatus)
                        .map(([value, label]) => ({
                            value,
                            label: (
                                <Badge variant={label.variant as VariantType}>
                                    {label.icon}
                                    {" "}
                                    {label.text}
                                </Badge>
                            ),
                        }))}
                    searchMinimum={10}
                    onSelected={value => onChange(value as TicketTaskState)}
                />
            </Dropdown.Menu>

        </Dropdown>

    );
}

TaskStatus.defaultProps = {
    className: "",
};
